import Icon from "assets/icons";

export default function NoTicketPrivilegesAvailable() {
  return (
    <div className="noPrivilegesView">
      <Icon.NoPrivileges />
    </div>
  );
}
